import { render, staticRenderFns } from "./collection-card.vue?vue&type=template&id=5a7a134e"
import script from "./collection-card.ts?vue&type=script&lang=ts&external"
export * from "./collection-card.ts?vue&type=script&lang=ts&external"
import style0 from "./collection-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports